import cls from 'classnames';

import useStyles from './slideStyles';
import { BulletSliderItem } from './types';

function SliderFrame({ title, header = null, description }: BulletSliderItem) {
  const classes = useStyles();

  return (
    <div>
      <div>
        {header}
        <div className={classes.content}>
          <h3 className={classes.title}>{title}</h3>
          <div className={cls('fs-20', classes.description)}>{description}</div>
        </div>
      </div>
    </div>
  );
}

export default SliderFrame;
